import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import config from "../config";
import Department from "../entities/Department";
import { useAuth } from "../context/Auth";

interface Props {
  defaultValue?: number | number[];
  onChange?: (value: any) => void;
  disabled?: boolean;
  multiple?: boolean;
}

const DepartmentSelect = ({ defaultValue, onChange, disabled, multiple }: Props) => {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [selected, setSelected] = useState<number | number[] | undefined>(defaultValue);
  const { fetchWithUser } = useAuth()

  useEffect(() => {
    const url = `${config.apiUrl}/CodeTable/GetDepartmentList`;
    fetchWithUser(url)
      .then((response) => response.json())
      .then((data) => setDepartments(data));
  }, [fetchWithUser]);

  return (
    <FormControl variant="outlined">
      <InputLabel>Department</InputLabel>
      <Select
        value={selected}
        onChange={(e: any) => {
          const value = e.target.value;
          setSelected(value);
          onChange && onChange(value);
        }}
        label="Department"
        disabled={disabled}
        multiple={multiple}
      >
        {departments.map((department: any) => (
          <MenuItem key={department.key} value={department.key}>{department.value}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DepartmentSelect;
